import { jsx as e, jsxs as p } from "react/jsx-runtime";
import { createStyles as f, rem as o, Box as a } from "@mantine/core";
import { useMediaQuery as h } from "@mantine/hooks";
import { useMemo as S } from "react";
import "../ProductTile/ProductTileSkeleton.js";
import { IconStar as i } from "../Icon/icons/Star.js";
const d = f(() => ({
  container: {
    display: "flex",
    gap: "1px"
  },
  halfStarContainer: {
    position: "relative"
  },
  halfStar: {
    position: "absolute",
    left: 0,
    zIndex: 1
  },
  halfStarLarge: {
    clip: `rect(0, ${o(8)}, ${o(16)}, 0)`
  },
  halfStarSmall: {
    clip: `rect(0, ${o(7)}, ${o(14)}, 0)`
  }
})), N = ({ max: s = 5, value: c }) => {
  const { classes: n, cx: m } = d(), t = h(`(max-width: ${o(576)})`), l = S(() => t ? 14 : 16, [t]);
  return e(a, { className: n.container, children: [...Array(s).keys()].map((r) => r < c && r + 1 > c ? p(a, { className: n.halfStarContainer, children: [e(a, { className: m(n.halfStar, { [n.halfStarLarge]: !t }, { [n.halfStarSmall]: t }), component: "span", c: "orange", children: e(i, { size: l }) }), e(a, { component: "span", c: "gray.3", children: e(i, { size: l }) })] }, r) : r < c ? e(a, { component: "span", c: "orange", children: e(i, { size: l }) }, r) : e(a, { component: "span", c: "gray.3", children: e(i, { size: 16 }) }, r)) });
};
export {
  N as Rating
};
